<template>
  <div>
    <button
      v-if="datos.cliente_nit"
      @click="refresh(datos)"
      class="btn btn-success btn-sm btn-block"
    >
      Ver saldo de Cliente
    </button>
    <br />
    <div v-if="permitir == 1" class="text-info col-6">
      <h5 class="text-danger">
        Saldo Pendiente: Q {{ datos.cliente_nit.saldo }} &nbsp;
        <button
          class="btn btn-secondary btn-sm"
          @click="setDefault"
          type="button"
        >
          Limpiar Datos
        </button>
      </h5>
    </div>
    <div class="table-responsive">
      <!-------------------- Tabla de Resultados -------------------->
      <div v-if="permitir == 1" class="table-responsive tableFixHead">
        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width: 8%">Nit</th>
              <th>Nombre</th>
              <th>Dirección</th>
              <th>Documento</th>
              <th style="width: 10%">Fecha</th>
              <th class="text-right">cargos</th>
              <th class="text-right">abonos</th>
              <th class="text-right">Saldo</th>
              <th class="text-right">Acumulado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in data" :key="item.id">
              <td>{{ item.nit }}</td>
              <td>{{ item.nombre }}</td>
              <td>{{ item.direccion }}</td>
              <td>{{ item.documento }}</td>
              <td>{{ item.fecha }}</td>
              <td class="text-right">{{ item.cargos }}</td>
              <td class="text-right">{{ item.abonos }}</td>
              <td class="text-right">{{ item.saldo }}</td>
              <td class="text-right">{{ item.acumulado }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-------------------- END - Basic Table -------------------->
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    PaginationComponent,
  },
  props: {
    datos: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data: null,
      cliente: {},
      permitir: 0,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    setDefault() {
      let self = this;
      self.$emit("setDefault");
      self.permitir = 0;
    },
    refresh(datos) {
      let self = this;
      DynamicService.getAction(
        "cat",
        "clientes",
        datos.cliente_nit.nit,
        "estado_cuenta",
        { solo_con_saldo: 1 }
      )
        .then((response) => {
          self.data = response.data.estado_cuenta;
          self.permitir = 1;
        })
        .catch((err) => {});
    },
  },
};
</script>
